<template>
  <div
    data-qa="results-placeholder"
    class="d-flex flex-column align-center text-center"
  >
    <v-img
      data-qa="results-placeholder-image"
      alt="Лупа"
      :src="src"
      :height="imgHeight"
      :width="imgWidth"
    />
    <div
      v-if="title"
      data-qa="results-placeholder-title"
      class="mt-6 text-h6"
    >
      {{ title }}
    </div>
    <div
      v-if="text"
      data-qa="results-placeholder-text"
      v-bind="{
        ...textProps
      }"
      :class="[title ? 'mt-2' : 'mt-6', textProps.class]"
      v-html="text"
    />
    <div
      v-if="subtext"
      data-qa="results-placeholder-subtext"
      class="mt-2 text-body-2 text-ui-kit-text-secondary"
      v-html="subtext"
    />
    <div
      v-if="hasButton"
      class="mt-6"
    >
      <v-btn
        color="ui-kit-bg-primary"
        data-qa="results-placeholder-button"
        variant="flat"
        rounded
        @click="emit('click:button')"
      >
        <span class="text-primary">
          {{ buttonText }}
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  imgWidth: { type: String, default: '150' },
  imgHeight: { type: String, default: '150' },
  src: { type: String, default: '' },
  text: { type: String, default: '' },
  subtext: { type: String, default: '' },
  textProps: { type: Object as PropType<Record<string, unknown>>, default: () => ({}) },
  title: { type: String, default: '' },
  buttonText: { type: String, default: '' },
})

const emit = defineEmits(['click:button'])
const slots = useSlots()

const hasButton = computed(() => props.buttonText.length > 0 || slots['results-placeholder-button'])
</script>
